import { Layout } from "../components/Layout";
import { Hero } from "../components/Hero";
import { Features } from "../components/Features";
import { HowItWorks } from "../components/HowItWorks";
import { Showcase } from "../components/Showcase";
import { Trust } from "../components/Trust";
import { Faq } from "../components/Faq";
import { CTA } from "../components/CTA";

/** The landing home page (route "/"). */
export function Home(): JSX.Element {
  return (
    <Layout>
      <Hero />
      <Features />
      <HowItWorks />
      <Showcase />
      <Trust />
      <Faq />
      <CTA />
    </Layout>
  );
}
